import SportOnboarding from "./components/SportOnboarding";
import { cyclingConfig } from "./ch/sportConfig";

const Cycling = () => {
  return <SportOnboarding sportConfig={cyclingConfig} navKey="cycling" />;
};

export default Cycling;
